
import { Box } from '@mui/material';


const Usecases = () => {
    return (
        <Box sx={{ alignItems: 'center' }}>
           
        </Box>
    );
}

export default Usecases;
